import React from 'react';
import styled from '@emotion/styled';
import { Box, Button, Card, Link, Typography } from '@mui/material';

export const BodyTextTypography = styled(Typography)({
  marginBottom: '3px',
  color: 'var(--Secondary-400, #495990)',
  fontFamily: 'Actor',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 400,
  letterSpacing: '0.5px',
  textDecorationStyle: 'solid',
  textDecorationSkipInk: 'none',
  textDecorationThickness: 'auto',
  textUnderlineOffset: 'auto',
  textUnderlinePosition: 'from-font'
});

export const MainTextTypography = styled(Typography)({
  color: 'var(--Secondary-500-Main, #222F59)',
  fontFamily: 'Actor',
  fontStyle: 'normal',
  fontWeight: 400,
  letterSpacing: '0.7px'
});

export const IconStyles = { width: '48px', height: '48px' };
export const SmallIconStyles = {
  width: '24px',
  height: '24px'
};
export const IconButtonStyles = {
  position: 'absolute',
  top: 16,
  right: 16,
  padding: '8px',
  zIndex: 1
};
export const DialogStyles = {
  margin: 'auto',
  display: 'block',
  width: '80%',
  maxWidth: '800px'
};

export const StyledLink = styled(Link)<{ component?: React.ElementType }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #0073e6;
  font-weight: bold;
  font-size: 16px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: #0056b3;
  }
`;

export const StyledButton = styled(Button)({
  backgroundColor: '#6FCF97',
  borderRadius: '8px',
  width: '10%',
  height: '40px',
  fontSize: '16px',
  position: 'absolute',
  right: 1,
  bottom: 16,
  color: '#000C57',
  fontWeight: 400,
  fontFamily: 'Actor',
  '&:hover': {
    backgroundColor: '#55D484'
  }
});

export const StyledCard = styled(Card)<{ isSelected: boolean }>(
  ({ isSelected }) => ({
    width: '250px',
    textAlign: 'center',
    cursor: 'pointer',
    border: '1px solid #E0E0E0',
    backgroundColor: isSelected ? '#F4F6F8' : '#FFFFFF',
    boxShadow: 'none',
    transition: 'background-color 0.3s, box-shadow 0.3s, transform 0.2s ease',
    marginRight: '-1px',
    '&:hover': {
      backgroundColor: '#DDE5F2',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
    },
    '&:first-of-type': { borderRadius: '8px 0 0 8px' },
    '&:last-of-type': { borderRadius: '0 8px 8px 0' },
    '&:active': { transform: 'scale(0.98)' }
  })
);

export const BookmarkWrapper = styled(Box)`
  display: flex;
  padding: 16px 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 6px;
  background: #f3f7ff;
  margin-bottom: 24px;
  cursor: pointer;
`;
